const capitalizeFirstLetter = {
    install(Vue) {
        Vue.filter('capitalizeFirstLetter', (string) => {
            if(string){
                // BRR whitelabel must be always Uppercase
                if (string.toUpperCase() === 'BRR') return string.toUpperCase()               
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
            }
        });
    },
};

export default capitalizeFirstLetter